import styled, { createGlobalStyle } from 'styled-components'

export const Container = styled.main`
  @media only screen and (min-width: 1024px) {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  flex: 1;
  display: flex;
  flex-direction: column;
`;

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
    font-family: Montserrat, sans-serif !important;
  }

  #root {
    flex: 1;
    display: flex;
  }

  body {
    -webkit-font-smoothing: antialiased !important;
    display: flex;
    flex: 1;
  }

  .layout-cols {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  /* INICIO HEADER */
  .login__header {
    padding-top: 15px;
  }

  .login__logo-container {
    padding-bottom: 19px;
    margin-bottom: 24px;
    box-shadow: 0px 2px 0px #00000014;
  }

  .login__logo {
    display: block;
    width: 80%;
    max-width: 100px;
    margin: 0 auto;
  }
  /* FIM HEADER */

  .login__area {
    margin: 0 24px;
    background-color: #FFF;
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  .login__area .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
  }

  .login__area .login__form {
    margin: auto;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  @media only screen and (min-width: 768px) {
    body {
      background-color: #F9F9F9;
    }

    .login__area .content {
      position: relative;
    }

    .login__header {
      margin: 0 auto;
    }

    .login__logo-container {
      padding-bottom: 0;
      box-shadow: none;
      margin-bottom: 0;
    }

    .login__logo {
      max-width: 234px;
    }

    .login__area {
      flex: 1;
      display: flex;
      flex-direction: column;
      box-shadow: 0px 3px 6px #00000029;
      border-radius: 10px;
      padding: 30px;
      width: 100%;
      max-width: calc(50% + 30px);
      margin: 30px auto;

      @media only screen and (min-width: 1024px) {
        max-width: calc(34% + 30px);
      }
      
      @media only screen and (min-width: 1366px) {
        max-width: calc(26% + 30px);
      }
    }
  }

  @media only screen and (min-height: 800px) {
    .login__area {
      padding: 40px;
    }
  }

  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  .rotating {
    -webkit-animation: rotating 0.7s linear infinite;
    -moz-animation: rotating 0.7s linear infinite;
    -ms-animation: rotating 0.7s linear infinite;
    -o-animation: rotating 0.7s linear infinite;
    animation: rotating 0.7s linear infinite;
  }
`;
